import type {PreSendCollector} from './index';


export const routePageCollector: PreSendCollector = {
  id: 'route-page',
  when: ({history}) => Boolean(history?.location?.pathname),
  collect: async ({history}) => {
    const queryParams = history.location.query;
    return {
      ...queryParams,
    };
  },
};
